import type { EventImpact, SextantEvent } from '@/types/event'
import { formatDate, formatTime } from '@/lib/format'

const IMPACT_STYLE: Record<EventImpact, { dot: string; label: string; text: string }> = {
  low: { dot: 'bg-faint', label: 'LOW', text: 'text-muted' },
  medium: { dot: 'bg-bernstein', label: 'MED', text: 'text-bernstein' },
  high: { dot: 'bg-loss', label: 'HIGH', text: 'text-loss' },
}

interface EventItemProps {
  event: SextantEvent
  compact?: boolean
}

/**
 * Eine Zeile in der Event-Liste. `compact` (Dashboard-Widget) zeigt
 * nur erste Zeile mit Datum, Country, Title; Detail-Modus zeigt mehr.
 */
export function EventItem({ event, compact = false }: EventItemProps) {
  const dateLabel = formatDate(event.event_date)
  const timeLabel = formatTime(event.event_date)

  const impactStyle = event.impact ? IMPACT_STYLE[event.impact] : null

  return (
    <div className="hairline-b flex flex-col gap-2 py-4">
      <div className="flex flex-col gap-2 md:flex-row md:items-baseline md:justify-between md:gap-4">
        <div className="flex min-w-0 flex-wrap items-baseline gap-x-3 gap-y-1">
          {impactStyle && (
            <span className={`tracked-caps text-[10px] ${impactStyle.text}`}>
              {impactStyle.label}
            </span>
          )}
          <span className="font-mono text-xs text-muted">{dateLabel}</span>
          {event.event_type === 'earnings' && event.ticker ? (
            <span className="tracked-caps text-[10px] text-bernstein">{event.ticker}</span>
          ) : event.country ? (
            <span className="tracked-caps text-[10px] text-faint">{event.country}</span>
          ) : null}
          <p className="min-w-0 break-words text-sm text-ink">{event.title}</p>
        </div>
        {!compact && <p className="shrink-0 font-mono text-xs text-muted">{timeLabel}</p>}
      </div>
    </div>
  )
}
